try {
  const html = document.getElementById('html');
  const onScroll = () => {
    const scroll = document.documentElement.scrollTop;
    if (scroll > 0) {
      html.classList.add('scrolled');
    } else {
      html.classList.remove('scrolled');
    }
  };
  window.addEventListener('scroll', onScroll);
}catch (e){
  console.log(e)
}

/* Foreach für querySelectorAll und getElementsByClassName */
NodeList.prototype.forEach = HTMLCollection.prototype.forEach = function (callback) {
    return [].forEach.call(this, function (item) {
        callback(item);
    });
};
NodeList.prototype.toArray = HTMLCollection.prototype.toArray = DOMTokenList.prototype.toArray = function () {
    let array = [];
    for (let i = 0; i < this.length; i++) {
        array.push(this[i]);
    }
    return array;
};


function shuffle(array) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}


if(document.querySelector('.header__desktop .sg-search-button') !== null){
  document.querySelector('.header__desktop .sg-search-button').addEventListener('click', function(e){
    e.preventDefault();
    location.href = '/search';
  });
}


if(document.getElementsByClassName('sg-accordion-toggle-button').length > 0){
  document.getElementsByClassName('sg-accordion-toggle-button').forEach(function(button) {
    console.log(button);
    button.addEventListener('click', function(e){
      e.preventDefault();
    });
  });
}


if(document.getElementById("sg-timer-container") !== null){
  // Set the date we're counting down to
  var countDownDate = new Date("Feb 28, 2024 23:59:59");
  countDownDate = countDownDate.getTime()  + (60 * 1000 * 60);
  
  // Update the count down every 1 second
  var timerInterval = setInterval(function() {
    // Get today's date and time
    let now = new Date();
    now = now.getTime() + (60 * 1000 * 60);
    
    console.log(countDownDate);
    console.log(now);
  
    // Find the distance between now and the count down date
    let distance = countDownDate - now;
  
    // Time calculations for days, hours, minutes
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  
    // Display the result in the element
    document.getElementById("sg-timer-value-days").innerHTML = days;
    document.getElementById("sg-timer-value-hours").innerHTML = hours;
    document.getElementById("sg-timer-value-minutes").innerHTML = minutes;

    // If the count down is finished remove timer
    if (distance < 0) {
      clearInterval(timerInterval);
      document.getElementById("sg-timer-container").style.display = "none";
    }
    
  }, 1000);
}


/*
function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
} 


if(document.getElementById('sg-popup-container') !== null && getCookie('mydealz-popup-angezeigt') !== 'true'){
  if(document.referrer.includes('mydealz')){
    document.getElementById('sg-popup-container').classList.add('active');
  }
  document.getElementById('sg-popup-close-button').addEventListener('click', function() {
    document.getElementById('sg-popup-container').classList.remove('active');
    document.cookie="mydealz-popup-angezeigt=true;max-age=31560000000;path=/";
  });
}
*/

